import { useEffect } from 'react';
import { useTitle } from '../../contexts/TitleContext';

const NoPermissionPage = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('');
  }, []);

  return (
    <div className="no-permission-page">
      <span className="message">
        Please wait while the application loads. If this page persists, please check your permissions for this resouce, and
        contact support.
      </span>
    </div>
  );
};

export default NoPermissionPage;
